import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {OrderListAction} from 'src/app/enums/OrderListAction';
import Order from 'src/smoothr-web-app-core/models/Order';
import SubscriptionArticles from 'src/smoothr-web-app-core/models/Subscription';
import {RepositoryService} from 'src/smoothr-web-app-core/services/repository/repository.service';
import {OrderUtils} from 'src/smoothr-web-app-core/utils/order-utils';
import {numberD, numberToCurrency} from 'src/smoothr-web-app-core/utils/utils';

@Component({
	selector: 'app-order-subscription-item',
	templateUrl: './order-subscription-item.component.html',
	styleUrls: ['./order-subscription-item.component.scss']
})
export class OrderSubscriptionItemComponent {
	@Output() action = new EventEmitter<void>();
	@Input() editable = true;
	@Input() subscriptionUser: SubscriptionArticles[] = [];
	OrderUtils = OrderUtils;
	isSomeOptionFullPrice = false;
	needsConfiguration = false;
	subscriptionPrice = 0;
	numberToCurrency = numberToCurrency;
	private prevPromoState = false;
	private prevQuantity = 1;
	public isArticleIsSubscription: boolean = false;
	constructor(
		private cd: ChangeDetectorRef,
		private repository: RepositoryService,
		private modalCtrl: ModalController
	) {}

	private _subscription: SubscriptionArticles;

	get subscriptionArticle(): SubscriptionArticles {
		return this._subscription;
	}

	@Input()
	set subscription(value: SubscriptionArticles) {
		this._subscription = value;
		this.reloadSubscription();
	}

	private _order: Order;

	get order(): Order {
		return this._order;
	}

	@Input()
	set order(value: Order) {
		this._order = value;
		this.reloadSubscription();
	}

	delete() {
		this.action.emit();
	}

	reloadSubscription() {
		this.needsConfiguration = false;
		this.isSomeOptionFullPrice = false;
		this.subscriptionPrice = 0;
		this.prevPromoState = false;
		this.prevQuantity = 1;
		if (!this.subscriptionArticle || !this.order || !this.order.preorder) {
			this.subscriptionPrice = 0;
			return;
		}

		this.subscriptionPrice = this.subscriptionArticle?.prices[0]?.price
			? numberD(this.subscriptionArticle?.prices[0]?.price)
			: 0;
	}
}
